angular.module('b2bLoginApp.services').factory('Rate', ['$resource',
    function ($resource) {
        return $resource('site-rates/:siteId/ranges', { siteId: '@siteId'}, {
            'query': { isArray: false }
        });
    }
]);
